import moment from 'moment';
import { navigate } from 'hookrouter'
import { HandlePatchBooking, HandleRemoveBooking } from './requests/BookingRequests';
import { bookingStatusOptions } from './shared/translations';

export function getLastDayToRegister(course) {
    if (course.startDate !== null) {
        return moment.utc(course.startDate).local().subtract(1, 'days').format('YYYY-MM-DD');
    }
    return null;
}
export function getLastDayToCancelBooking(course) {
    if (course.startDate !== null) {
        return moment.utc(course.startDate).local().subtract(1, 'days').format('YYYY-MM-DD');
    }
    return null;
}
export function filterBookingsForNonAdmin(course, user) {
    const tempList = [];
    course.bookings.forEach((booking) => {
        if (
            booking.coaEmpId.toUpperCase() === user.id.toUpperCase() ||
            booking.status === (bookingStatusOptions.Confirmed.value)
        ) {
            tempList.push(booking);
        }
    })
    return tempList;
}

export async function RemoveBooking(booking, dispatch, submitHandler) {
    var response = await HandleRemoveBooking(booking.id)
    if (response.success) {
        dispatch({ type: 'SHOW_DELETED_TOAST' });
    }
    else {
        dispatch({ type: 'SHOW_ERROR_TOAST' });
    }
    submitHandler(booking.courseId);
    return navigate('/exlCourseDetails/' + booking.courseId);
}

export async function PatchBookings(initialBooking, booking, course, setStatus, dispatch) {
    var response = await HandlePatchBooking(initialBooking, booking, dispatch);
    if (response.success) {
        dispatch({ type: 'SHOW_SAVED_TOAST' });
    }
    else {
        setStatus(initialBooking.status);
        dispatch({ type: 'SHOW_ERROR_TOAST' });
    }
}

